import { UIText2 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './BuilderChatOnboardingContent.css';

interface IBuilderChatOnboardingContentProps {
  onboardingText: string;
  wide: boolean;
}

export const BuilderChatOnboardingContent: React.FC<IBuilderChatOnboardingContentProps> = ({
  wide,
  onboardingText,
}) => {
  return (
    <div className={clsx(styles['content'], wide && styles['wide'])}>
      <UIText2 color="text-inverted-default" whiteSpace="pre-line">
        {onboardingText}
      </UIText2>
    </div>
  );
};
